export default "__VITE_ASSET__39EMQfaM__"